import React, { Component } from "react"
import Sidebar from '../components/sidebar'
import { Fade } from 'react-reveal';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Table from 'react-bootstrap/Table'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

class Prices extends Component {
  render() {
    return (
      <>
        <Jumbotron className="subpageHeader" fluid>
          <Fade>
            <Container>
              <h1>Ürün ve Hizmet Ücretleri</h1>
              <Breadcrumb>
                <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                <Breadcrumb.Item active>Ürün ve Hizmet Ücretleri</Breadcrumb.Item>
              </Breadcrumb>
            </Container>
          </Fade>
        </Jumbotron>
        <Container>
          <Row>
            <Col className="subpageContent" sm={9}>
              <Fade bottom cascade>
                <h2>Ürün ve Hizmet Ücretleri</h2>
                <div class="table-responsive">
                  <Table bordered hover size="md">
                    <thead className="thead-dark">
                      <tr>
                        <th>Masraf Adı</th>
                        <th>Tutar</th>
                        <th width="50">Açıklama</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Tahsis Ücreti</td>
                        <td>%0,5</td>
                        <td>
                          {['top'].map((placement) => (
                            <OverlayTrigger
                              trigger="click"
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover id={`popover-positioned-${placement}`}>
                                  <Popover.Content>
                                    Tahsis ücreti müşteriden peşin olarak tahsil edilecektir. Ödenecek toplam tutar masrafları içermemektedir. Bu tablo bilgi amaçlıdır. Türkiye Emlak Katılım Bankası A.Ş.’yi hiçbir şekilde taahhüt altına sokmaz.
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <Button variant="link" className="infoButton"><FontAwesomeIcon size="lg" icon={faInfoCircle} /></Button>
                            </OverlayTrigger>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td>Ekspertiz Ücreti</td>
                        <td>5500 TL</td>
                        <td>
                          {['top'].map((placement) => (
                            <OverlayTrigger
                              trigger="click"
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover id={`popover-positioned-${placement}`}>
                                  <Popover.Content>
                                    Ekspertiz ücreti tahmini olarak hesaplanmıştır. Bu ücrete KDV, belediye harcı ve yol ücreti dahil değildir.
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <Button variant="link" className="infoButton"><FontAwesomeIcon size="lg" icon={faInfoCircle} /></Button>
                            </OverlayTrigger>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td>İpotek Tesis Bedeli</td>
                        <td>1620 TL</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </Table>
                  <p><small>* Kar oranı 60 ay vade ve 1.000,000 TL’ye kadar geçerlidir.</small></p>
                </div>
              </Fade>
            </Col>
            <Col sm={3}>
              <Sidebar />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Prices;